export const environment = {
    production: true,
    env: 'prod',
    dsn: 'https://a1ddfe6d55184e5ead5fda147a4427f2@o1240364.ingest.sentry.io/4505226793844736',
    envVar: {
        backendUrl: 'https://stage.printportal-se.bauermediaoutdoor.com/backend/',
        socketUrl: 'wss://websocket.stage.printportal-se.bauermediaoutdoor.com:443',
        frontendDomain: 'stage.printportal-se.bauermediaoutdoor.com',
    },
    features: {
        batRequestFlowEnabled: false, // This is a feature specific for the French market
        importAddressesEnabled: false,
        weekNumbersEnabled: true,
    }
};
